import React from 'react';
import { graphql } from 'gatsby';

import HeroComboSectionDS from 'design-system/src/components/organisms/HeroComboSection';
import { getImage } from '../../utils/media';

export default function HeroComboSection({
    image,
    featuredBlogPosts,
    featuredBlogPostsTitle,
    ...props
}: any) {
    return (
        <HeroComboSectionDS
            {...props}
            {...(featuredBlogPosts?.length
                ? {
                      links: {
                          items: featuredBlogPosts,
                          title: featuredBlogPostsTitle,
                      },
                  }
                : {
                      image: getImage(image),
                  })}
        />
    );
}

export const query = graphql`
    fragment DatoCmsHeroComboSection on DatoCmsHeroComboSection {
        preTitle
        preTitleTag
        title
        titleTag
        rating
        ratingLink {
            ...Button
        }
        description
        cta {
            ...Button
        }
        ctaSecondary {
            ...Button
        }
        image: imageAbmizable {
            ...SourceMedia
            gatsbyImageData(width: 1250, placeholder: BLURRED)
        }
        featuredBlogPostsTitle
        featuredBlogPosts {
            ...DatoCmsBlogPostLinkItem
        }
    }
`;
